import { Component, OnInit } from '@angular/core';
import { RedirectionService } from '~/core/services/redirection/redirection.service';
import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Component({
  templateUrl: './onebooking.component.html',
  styleUrls: ['./onebooking.component.scss'],
})
export class OneBookingComponent implements OnInit {
  constructor(
    private readonly redirectionService: RedirectionService,
    public readonly toggleService: ToggleService
  ) {}

  public ngOnInit(): void {
    if (!this.isOneBookingEnabled()) {
      this.redirectionService.redirect('/');
    }
  }

  private isOneBookingEnabled(): boolean {
    return this.toggleService.isEnabled(ToggleNameEnum?.OneBookingWidget);
  }

  public get oneBookingUrl(): string {
    const toggleVariant = ToggleNameEnum?.OneBookingWidget;

    return this.toggleService.getVariant(
      toggleVariant,
      'https://onebooking-widget.ig1.activities-stg.activities-stg-pbst.decathlon.io/'
    ) as string;
  }
}
